import { render, staticRenderFns } from "./DebtorFillType.vue?vue&type=template&id=51410462&"
import script from "./DebtorFillType.vue?vue&type=script&lang=js&"
export * from "./DebtorFillType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports